import React from "react";
import { ChartDataItem } from "./types";
import clsx from "clsx";
import Typography from "../Typography";

interface LegendProps {
  data: ChartDataItem[];
  activeIndex: number | null;
  onClick: (index: number) => void;
}

const ChartLegend: React.FC<LegendProps> = ({ data, activeIndex, onClick }) => {
  return (
    <div className="space-y-1">
      {data.map((item, idx) => {
        const isActive = activeIndex === idx;
        return (
          <button
            key={idx}
            onClick={() => onClick(idx)}
            className={clsx(
              "flex items-start px-2 py-1 gap-2 group w-full text-left transition-transform duration-200",
              isActive && "scale-[1.1] border shadow-md rounded-lg"
            )}
          >
            <span
              className={`w-4 h-4 rounded-full inline-block`}
              style={{ backgroundColor: item.color }}
            />
            <div className="flex flex-col">
              <Typography variant="Normal">{item.name}</Typography>
              <div className="flex gap-2">
                <Typography variant="Normal">
                  {item.hours ? `${item.hours}h` : `$${item.price?.toLocaleString()}`}
                </Typography>
                <Typography variant="Base" className="text-gray-500">
                  {item.percent}%
                </Typography>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ChartLegend;
